import { render, staticRenderFns } from "./FontsSettings.vue?vue&type=template&id=448ecf91&scoped=true&lang=pug"
import script from "./FontsSettings.vue?vue&type=script&lang=js"
export * from "./FontsSettings.vue?vue&type=script&lang=js"
import style0 from "./FontsSettings.vue?vue&type=style&index=0&id=448ecf91&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ecf91",
  null
  
)

export default component.exports